/**
 * ログ出力共通クラス
 */
export default class LogUtils {
  /**
   * ログを出力する
   * @name info
   * @param {string} message メッセージ
   */
  public static info(message: string) {
    // TODO : とりあえず、コンソールで出力する
    console.log(message);
  }
  /**
   * エラーログを出力する
   * @name error
   * @param {string} message メッセージ
   */
  public static error(message: string) {
    // TODO : とりあえず、コンソールで出力する
    console.log(message);
  }
}
